import Axios from '../baseApi';
import baseApi from "@/api/baseApi";

export default {
  delete(id) {
    return baseApi.delete(`api-registration/v1/registration-set/${id}`);
  },
  register(form) {
    return Axios.put('/api-registration/v1/registration-set', form);
  },
  fetchPrefill(pigStyId) {
    return Axios.get(`/api-registration/v1/registration-set/last/${pigStyId}`);
  }
}
